import React from 'react';
import { useTranslation } from 'react-i18next';

import { BasePaymentFailPopup } from '../BasePaymentFailPopup';

import css from './insufficientPaymentFailPopup.module.sass';

interface Props {
  buttonText?: string;
  onClose?: () => void;
  onContinue?: () => void;
  onMount?: () => void;
}

export const InsufficientPaymentFailPopup: React.FC<Props> = ({
  buttonText,
  onClose,
  onContinue,
  onMount,
}) => {
  const { t } = useTranslation(['common', 'app']);

  return (
    <BasePaymentFailPopup
      onContinue={onContinue}
      onClose={onClose}
      onMount={onMount}
      buttonText={buttonText || t('common:continue')}
    >
      <p className={css.description}>{t('app:insufficientFundsPopup.title')}</p>
      <p className={css.reason}>
        {t('app:insufficientFundsPopup.description')}
      </p>
    </BasePaymentFailPopup>
  );
};
